import { getLocalLogoUrl } from '../../Common/Utils/companyLogo';
/**
 * Colors_T41.jsx
 * Identity for B2C Template 41 — "Midnight Luxe" Theme
 * Crimson / Deep Violet / Warm Gold palette. Bold, dramatic, premium.
 */

export const mapB2CTenantToLanding = (tenantData) => {
  return {
      isPreview: tenantData?.isPreview ?? false,
    companyId:       tenantData?.companyId,
    branchId:        tenantData?.branchId,
    userId:          tenantData?.userId,
    logoUrl:         getLocalLogoUrl(tenantData?.domain),
    brandName:       tenantData?.branding?.brandName    || 'Midnight Travels',
    companyName:     tenantData?.branding?.companyName  || 'Midnight Travels',
    email:           tenantData?.branding?.email        || 'support@midnighttravels.com',

    phones:          Array.isArray(tenantData?.branding?.phones)
                     ? tenantData?.branding?.phones[0]
                     : tenantData?.branding?.phones || '9000000000',

    whatsapp:        tenantData?.branding?.whatsapp     || '9000000000',
    socials:         tenantData?.branding?.socials      || {},
     companyData:     tenantData?.companyData || {},
     seo: tenantData?.seo || {},

    themeColor1:     tenantData?.theme?.themeColor1 || tenantData?.theme?.themecolor1,
    themeColor2:     tenantData?.theme?.themeColor2 || tenantData?.theme?.themecolor2,
    themeColor3:     tenantData?.theme?.themeColor3 || tenantData?.theme?.themecolor3,
    themeColor4:     tenantData?.theme?.themeColor4 || tenantData?.theme?.themecolor4,
    themeColor5:     tenantData?.theme?.themeColor5 || tenantData?.theme?.themecolor5,

    headerBgOverride:   tenantData?.header?.bgColor,
    headerTextOverride: tenantData?.header?.textColor,
    footerBgOverride:   tenantData?.footer?.bgColor,
    footerTextOverride: tenantData?.footer?.textColor,

    headingFont: tenantData?.branding?.headingFont || 'Outfit',
    bodyFont:    tenantData?.branding?.bodyFont    || 'Manrope',

    heroData:        tenantData?.hero,
    aboutUs:         tenantData?.aboutUs,
    contactUs:       tenantData?.contactUs,
    activeModules:   tenantData?.activeModules,
  };
};

export const getB2CColors_T41 = (landingData) => {
  const crimson  = landingData?.themeColor1 || '#dc2626';  // Vivid Crimson — primary CTA
  const violet   = landingData?.themeColor2 || '#7c3aed';  // Deep Violet — secondary
  const gold     = landingData?.themeColor3 || '#f59e0b';  // Warm Gold — accent
  const dark     = landingData?.themeColor4 || '#0f172a';  // Deep Dark Navy — heroes/footer
  const warmBg   = landingData?.themeColor5 || '#fffaf7';  // Warm Off-White — page bg

  return {
    theme1: crimson,
    theme2: landingData?.footerBgOverride || dark,
    theme3: landingData?.headerBgOverride || '#ffffff',
    theme4: violet,
    theme5: warmBg,
    gold:   gold,

    headerText: landingData?.headerTextOverride || '#0f172a',
    footerText: landingData?.footerTextOverride || '#e2e8f0',

    topBarBg:   dark,
    topBarText: '#e2e8f0',
  };
};

export const toRgba = (color, alpha = 1) => {
  if (!color || !color.startsWith('#')) return color;
  const hex = color.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};
